<template>

    <nav id="main-nav" class="uk-navbar-container" uk-navbar>

        <!-- Mobile -->
        <div class="uk-hidden@l">

            <div class="uk-display-inline-block uk-width-1-1 ">
                <div class="uk-navbar-left uk-position-center-left uk-hidden@l">
                    <a class="uk-navbar-toggle" href="#" uk-toggle="target: #offcanvas-nav">
                        <span uk-navbar-toggle-icon></span>
                    </a>
                </div>

                <div class="uk-navbar-center uk-hidden@l">
                    <div class="uk-navbar-item uk-logo">
                        <img :src="cdnUrl + '/img/reminderbot.svg'" alt="Reminder Bot">
                    </div>
                </div>
            </div>

        </div>



        <!-- Desktop -->
        <div class="uk-navbar-left uk-visible@l">
            <div class="uk-navbar-item uk-logo">
                <img :src="cdnUrl + '/img/reminderbot.svg'" alt="Reminder Bot">
            </div>
        </div>

        <div class="uk-navbar-right uk-visible@l">
            <ul class="uk-navbar-nav">
                <li><a href="/login" class="uk-button uk-button-primary">Login <span class="uk-margin-small-left"><font-awesome-icon :icon="['far', 'sign-in']" /></span></a></li>
            </ul>
        </div>

    </nav>

</template>


<script>
    import {cdnUrl} from "../../../helpers";

    export default {
        name: 'HeaderWrapper',

        data () {
            return {

                isLoggedIn: this.$route.name === 'setTimezone',

            };
        },

        computed: {

            cdnUrl() {
                return cdnUrl;
            }

        },

        watch: {
            '$route' (to) {
                this.isLoggedIn = to.name === 'setTimezone'
            }
        }
    }
</script>
